import { Field, useField } from "formik";

// toggle field converts yes or no to true or false
const ToggleField = ({ form, radioTrueName, radioFalseName, fieldClassName, labelClassName, ...props }) => {
  const [field] = useField(props);

  // use `field` but override onChange
  return (
    <>
      <label htmlFor={`${props.id}-radio-true-id`} className={labelClassName}>
        <Field {...field} id={`${props.id}-radio-true-id`} className={fieldClassName} type="radio" value="1" />
        {radioTrueName}
      </label>
      <label htmlFor={`${props.id}-radio-false-id`} className={labelClassName}>
        <Field {...field} id={`${props.id}-radio-false-id`} className={fieldClassName} type="radio" value="0" />
        {radioFalseName}
      </label>
    </>
  );
};
export default ToggleField;
